import type React from 'react';

import { useLocation } from 'react-router';

import { Redirect } from '@change-corgi/core/react/router';

import { useLoginState } from 'src/app/shared/hooks/session';

export const RedirectToLoginIfNotAuth: React.FC = () => {
	const { pathname } = useLocation();
	const loginState = useLoginState();

	if (loginState !== 'AUTHENTICATED') {
		return <Redirect to={`/login_or_join?redirectTo=${pathname}`} />;
	}
	return null;
};
